import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import { ApolloClient, InMemoryCache } from "@apollo/client";
import {
  MUTATION_CREATE_FIELD_KEY_IN_NAMESPACE,
  MUTATION_CREATE_NAMESPACE,
  MUTATION_CREATE_ONE_LABEL,
  MUTATION_UPDATE_ONE_LABEL,
  QUERY_LABELS,
  QUERY_LABEL_EXISTS_IN_NAMESAPCE,
  QUERY_NAMESPACE,
} from "./lib/dev/graphql/updateMissingKey";

const client = new ApolloClient({
  uri: "http://localhost:8080/api/graphql",
  cache: new InMemoryCache(),
});

const handleLabel = async ({ value, rootPath, code }) => {
  const { data: labelExists, errors } = await client.query({
    query: QUERY_LABELS,
    variables: {
      where: {
        AND: [
          {
            fieldKey: {
              fieldKey: { equals: rootPath },
            },
          },
          { language: { code: { equals: code } } },
        ],
      },
    },
  });
  if (errors) {
    console.log(errors);
  }
  // if labels exists, then update field value using label key
  if (labelExists.labels.length > 0) {
    const { id: labelId } = labelExists.labels[0];
    await client.mutate({
      mutation: MUTATION_UPDATE_ONE_LABEL,
      variables: {
        id: labelId,
        value,
      },
    });
    console.log(`updated label ${rootPath} in language ${code}`);
  } else {
    console.log(`creating label ${rootPath} in language ${code}`);
    // if no label exists, then create it with language code
    const { data: createLabelData } = await client.mutate({
      mutation: MUTATION_CREATE_ONE_LABEL,
      variables: {
        value,
        fieldKey: rootPath,
        code,
      },
    });
    console.log(createLabelData.createLabel.id, "created label", rootPath);
  }
};

const updateMissingKey = async ({ lng, ns, key, fallbackValue }) => {
  console.log(`updateMissingKey: ${lng} ${ns} ${key} ${fallbackValue}`);
  let namespaceId = undefined;
  // check if namespace exists
  // fieldKey is the ns + key
  const fieldKey = `${ns}::${key}`;
  const { data: nsData } = await client.query({
    query: QUERY_NAMESPACE,
    variables: {
      ns,
      language: lng[0],
    },
  });
  // If the namespace doesn't exist, create it
  if (!nsData.namespaces.length) {
    const { data: nsCreate, errors } = await client.mutate({
      mutation: MUTATION_CREATE_NAMESPACE,
      variables: {
        ns,
      },
    });
    if (errors) {
      console.log(errors);
    }
    console.log(nsCreate.createNamespace.id, "created namespace", ns);
    namespaceId = nsCreate.createNamespace.id;
  } else {
    namespaceId = nsData.namespaces[0].id;
  }
  // Check if fieldKey already exists in the specified namespace
  const { data: existingLabel } = await client.query({
    query: QUERY_LABEL_EXISTS_IN_NAMESAPCE,
    variables: {
      fieldKey,
    },
  });
  // If the filedKey doesn't exist, create it
  if (!existingLabel.fieldKeys.length) {
    const { data: labelCreate, errors } = await client.mutate({
      mutation: MUTATION_CREATE_FIELD_KEY_IN_NAMESPACE,
      variables: {
        fieldKey,
        namespaceId,
      },
    });
    if (errors) {
      console.log(errors);
    }
    if (labelCreate.createFieldKey.id) {
      console.log("created label", fieldKey, "in namespace", ns);
    }
  } else {
    console.log(`${key} already exists in ${ns}`);
  }

  // Finally update the value of the fieldKey in the namespace
  const res = await handleLabel({
    code: lng[0],
    value: fallbackValue || "",
    rootPath: fieldKey,
  });
  return res;
};

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: "en-US",
    // debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    // true only in dev mode
    saveMissing: process.env.NODE_ENV === "development" ? true : false,
    saveMissingTo: "current",
    missingKeyHandler: async function (lng, ns, key, fallbackValue) {
      await updateMissingKey({
        lng,
        ns,
        key,
        fallbackValue,
      });
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
    },
  });

export default i18n;
